import { solveLevel, type GridPoint, type LevelSnapshot, type SolvedPath } from "@gridflow/core";
import type { LevelCatalogEntry } from "@gridflow/levels";

export interface HintResult {
  readonly color: string;
  readonly cells: readonly GridPoint[];
}

export interface HintService {
  getHint(level: LevelCatalogEntry, snapshot: LevelSnapshot): HintResult | null;
}

export class SolverHintService implements HintService {
  public getHint(level: LevelCatalogEntry, snapshot: LevelSnapshot): HintResult | null {
    const solution = solveLevel(level.config, {
      maxSolutions: 1,
      timeLimitMs: 2_000
    }).firstSolution;
    if (!solution) {
      return null;
    }

    const snapshotPaths = new Map(snapshot.paths.map((path) => [path.color, path]));
    const hintedPath =
      solution.find((path) => {
        const current = snapshotPaths.get(path.color);
        return current ? !current.isComplete : true;
      }) ?? solution[0];

    return hintedPath ? solvedPathToHint(hintedPath) : null;
  }
}

export function createSolverHintService(): HintService {
  return new SolverHintService();
}

function solvedPathToHint(path: SolvedPath): HintResult {
  return {
    color: path.color,
    cells: path.cells.map((cell) => ({ ...cell }))
  };
}
